/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The OneOfobservationsObservationObservedValue model module.
 * @module model/OneOfobservationsObservationObservedValue
 * @version v0.3
 */
export default class OneOfobservationsObservationObservedValue {
  /**
   * Constructs a new <code>OneOfobservationsObservationObservedValue</code>.
   * @alias module:model/OneOfobservationsObservationObservedValue
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OneOfobservationsObservationObservedValue</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OneOfobservationsObservationObservedValue} obj Optional instance to populate.
   * @return {module:model/OneOfobservationsObservationObservedValue} The populated <code>OneOfobservationsObservationObservedValue</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OneOfobservationsObservationObservedValue();
    }
    return obj;
  }
}
